export class MnFormatoAuditorByIdRequest {
    identInformeComercial: number = 0;
}

export class MnFormatoAuditorRequest {
    identFormatoAuditor: number = 0;
    jsonTable: string = '';
    identUsuario: number = 0;
}
